/* eslint-disable max-lines-per-function */
/* eslint-disable complexity */
import config from 'Cloud/config';
import { path, pathEq } from 'ramda';
import { connect } from 'react-redux';
import { removeItems } from 'reactApp/appHelpers/appHelpers';
import { HIDE_ADS, IS_BLOCKED, IS_ONPREMISE, IS_PUBLIC } from 'reactApp/appHelpers/configHelpers';
import { clearRenamedFileIdInsideViewer, getRenamedFileIdInsideViewer } from 'reactApp/appHelpers/updateRenamedFileInsideViewer';
import { AttachesSelectors } from 'reactApp/modules/attaches/attaches.selectors';
import { EAttachTypes } from 'reactApp/modules/attaches/attaches.types';
import { isDialogVisible } from 'reactApp/modules/dialog/dialog.selectors';
import { dispatchSearchRadar } from 'reactApp/modules/dwh/dwh.module';
import { getEditorsFor } from 'reactApp/modules/editor/editor.selectors';
import { selectFace } from 'reactApp/modules/faces/faces.module';
import { getFacesOnFile } from 'reactApp/modules/faces/faces.selectors';
import { IFaceWithCoordinates } from 'reactApp/modules/faces/faces.types';
import {
    getFeatureAttachesEnabled,
    getFeatureNewAdFormat,
    getFeaturePdfConverterStorage,
    getFeatureShowEditBtnForSharedFolder,
    getFeatureShowEditButtonForAttach,
} from 'reactApp/modules/features/features.selectors';
import { getParent, getWeblinkFromPublicId, isDocument, isImage, isPreviewable, isVideo } from 'reactApp/modules/file/utils';
import { isReadOnly, isThisOrParentMounted } from 'reactApp/modules/home/home.selectors';
import { addToFavorites, removeFromFavorites } from 'reactApp/modules/modifying/modifying.actions';
import { isOwnPublic } from 'reactApp/modules/public/public.selectors';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { getItemById, getStorageItemById, isMountedOrSharedFolder } from 'reactApp/modules/storage/storage.selectors';
import { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { markStoryAsViewed as markStoryAsViewedAction } from 'reactApp/modules/stories/stories.module';
import { getAdjacentStoryIds, getStoryForViewer } from 'reactApp/modules/stories/stories.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import {
    closeViewer,
    downloadArchiveItemRequest,
    publishItem,
    selectItemIndexInArray as selectItemIndexInArrayAction,
} from 'reactApp/modules/viewer/viewer.module';
import { ViewerSelectors } from 'reactApp/modules/viewer/viewer.selectors';
import { NUMBER_TO_PRELOAD } from 'reactApp/ui/ReactViewer/ReactViewer.constants';
import { getFitContentOption, getItemImageUrl, getPosterUrl, setFitContentOption } from 'reactApp/ui/ReactViewer/ReactViewer.helpers';
import { ReactViewerComponent } from 'reactApp/ui/ReactViewer/ReactViewerComponent';
import { noopVoid } from 'reactApp/utils/helpers';

// eslint-disable-next-line max-lines-per-function
const mapStateToProps = (state, props) => {
    const { isStock } = props;
    const file = ViewerSelectors.getViewerItem(state);
    const indexInArray = ViewerSelectors.getViewerItemIndexInArray(state);
    const itemStorage = ViewerSelectors.getViewerItemStorage(state) ?? file?.storage;
    const isActionOpen = ViewerSelectors.isViewerActionOpen(state);
    const ids = ViewerSelectors.getViewerItemIds(state);
    const itemCount = ViewerSelectors.getViewerItemCount(state);
    const hasMoreToLoad = ViewerSelectors.hasMoreToLoad(state);
    const gaSuffix = ViewerSelectors.getViewerGa(state);
    const activeArchiveItem = ViewerSelectors.getArchiveActiveItem(state);
    const isAuthorized = !UserSelectors.isAnonymous(state);
    const isAttachesEnabled = !!getFeatureAttachesEnabled(state);
    const preloadUrls: { url: string; id: string }[] = [];
    const isEditable = getEditorsFor(state, file)?.length > 0;
    const email = UserSelectors.getEmail(state);
    const isOwner = isOwnPublic(state);
    const isAttaches = itemStorage === EStorageType.attaches || itemStorage === EStorageType.viewerAttaches;
    const attachesSearchState = AttachesSelectors.getSearchState(state);
    const attachesQuery = attachesSearchState?.query;
    const attachesSearchedItem = file && !!attachesSearchState && AttachesSelectors.getAttachById(state, file.id);
    const attachesSearchedItemPos = attachesSearchedItem ? attachesSearchedItem?.pos : undefined;
    const isDialogShown = isDialogVisible(state);
    const isMountedFolder = isThisOrParentMounted(state, file?.parent);
    const hideAdsOnAttaches = UserSelectors.isHideAdInMail(state);
    const showBottomAds = itemStorage === EStorageType.public && !HIDE_ADS;
    const isNewAdFormat = getFeatureNewAdFormat(state);
    const pdfConverterStorage = getFeaturePdfConverterStorage(state, file);
    const disableClose = IS_BLOCKED;
    const isPublic = IS_PUBLIC;
    const isAttach = itemStorage === EStorageType.attaches || itemStorage === EStorageType.viewerAttaches;
    const isSearch = itemStorage === EStorageType.search;
    const attachType = file && 'type' in file && file.type;
    const isAttachesCloudStock = isAttach && attachType === EAttachTypes.cloudStock;
    const isAttachesCloud = isAttach && attachType === EAttachTypes.cloud;

    let faces: IFaceWithCoordinates[] = [];
    if (itemStorage === EStorageType.public) {
        faces = getFacesOnFile(state, file?.id?.replace(getWeblinkFromPublicId(file?.id) ?? '', ''));
    }

    let isPreviewableItem = isPreviewable(file, itemStorage);

    if (isAttaches && pathEq(['subKind'], 'archive', file) && !isAttachesCloudStock && !isAttachesCloud) {
        // В аттачах все просматриваем, идем в почтовое апи
        // На клауд стоки только зип, и  нужный isPreviewableItem уже выставлен.
        isPreviewableItem = attachType !== EAttachTypes.temporary;
    }

    if (isPreviewableItem && file?.kind === 'document' && isAttaches && !isAttachesCloudStock && !isAttachesCloud) {
        isPreviewableItem = config.get('DOCUMENTS_VIEW_O2_VIEWER')?.length > 0;
    }

    // Файл не надо увеличивать/уменьшать, если мы его не показываем
    const disableZoom = !isPreviewableItem || itemStorage === EStorageType.story;

    // Не показываем кнопку на аттачах типа cloud и cloud_stock
    const isAttachType = attachType === EAttachTypes.attach;
    const showEditButtonAttachCondition = isAttaches ? isAttachType && getFeatureShowEditButtonForAttach(state) : true;

    // Условие показа кнопки редактирования для файлов в шаренных папках
    const sharedFolderState = isMountedOrSharedFolder(state, file);
    const sharedFolderFile = sharedFolderState.isMounted;
    const sharedFolderFileBtnFeature = getFeatureShowEditBtnForSharedFolder(state);

    /**
     * Показ кнопки редактирования на mounted и (public не для владельцев) папках всегда регулируется фичей,
     * а для шареных папок показываем всегда (шареных значит для владельцев показываем всегда)
     */
    const showEditButtonForFileInSharedFolder = sharedFolderFile ? sharedFolderFileBtnFeature : true;

    // B2BCLOUD-416 скрываем кнопку для файлов из поиска, в случае, если они находятся в readonly папке
    const homeFileFolder = getParent(file?.home || '/');
    const isReadonlyHomeFolder = isReadOnly(state, homeFileFolder);
    const showEditButtonInRoFolderFromSearch = IS_ONPREMISE && isSearch ? !isReadonlyHomeFolder : true;
    // Выключаем кнопку на ONPREMISE, если папка readOnly
    const { folderId, isMounted } = isMountedOrSharedFolder(state, file);
    const folder = folderId && getItemById(state, folderId);
    // @ts-ignore
    const disableButtonInReadOnlyFolder = isMounted && folder && folder.isReadOnly && IS_ONPREMISE;

    const showEditButton =
        isEditable &&
        !isPublic &&
        !isStock &&
        isDocument(file) &&
        isPreviewableItem &&
        !path(['isReadOnly'], file) &&
        showEditButtonAttachCondition &&
        showEditButtonForFileInSharedFolder &&
        showEditButtonInRoFolderFromSearch &&
        !disableButtonInReadOnlyFolder;

    // TODO: Move preloadUrls update to store or saga?
    // in viewer start and selectIndex?
    if (props.enablePreload && indexInArray !== null && itemStorage && ids) {
        for (let i = indexInArray; i < indexInArray + NUMBER_TO_PRELOAD && i < ids.length; i++) {
            const item = getStorageItemById(state, itemStorage, ids[i]);

            preloadUrls.push({
                url: isVideo(item) ? getPosterUrl(item) : (isImage(item) && isPreviewable(item, itemStorage) ? getItemImageUrl(item) : ''),
                id: item?.id || '',
            });
        }
    }

    let backItemIndexInArray: number | null = null;
    let forwardItemIndexInArray: number | null = null;
    if (indexInArray !== null && indexInArray !== undefined) {
        backItemIndexInArray = !!ids && indexInArray > 0 ? indexInArray - 1 : null;
        forwardItemIndexInArray = !!ids && indexInArray >= 0 && indexInArray + 1 < ids.length ? indexInArray + 1 : null;

        if (itemStorage === EStorageType.story) {
            const { prevStoryId, nextStoryId } = getAdjacentStoryIds(state);
            backItemIndexInArray = backItemIndexInArray ?? (prevStoryId ? -1 : null);
            forwardItemIndexInArray = forwardItemIndexInArray ?? (nextStoryId ? ids?.length ?? null : null);
        }
    }

    let storyType, bottomTitle, bottomSubTitle, topSubTitle, topTitle, storyId, isStoryViewed;
    if (itemStorage === EStorageType.story) {
        const data = getStoryForViewer(state, file?.id);
        storyType = data?.type;
        bottomTitle = data?.bottomTitle;
        bottomSubTitle = data?.bottomSubTitle;
        topTitle = data?.topTitle;
        topSubTitle = data?.topSubTitle;
        storyId = data?.id;
        isStoryViewed = data?.viewed;
    }

    const isSearchAnalyticsRequestAvailable =
        itemStorage === EStorageType.search || (!!attachesSearchedItem && isAttaches && !!attachesQuery);

    return {
        file,
        activeArchiveItem,
        ids,
        indexInArray,
        itemStorage,
        backItemIndexInArray,
        forwardItemIndexInArray,
        preloadUrls,
        itemCount,
        hasMoreToLoad,
        gaSuffix: gaSuffix ? `_${gaSuffix}` : '',
        isActionOpen,
        isPreviewableItem,
        isAuthorized,
        isAttaches,
        getFitContentState: () => getFitContentOption(email),
        setFitContentState: (isFitContent) => setFitContentOption(email, isFitContent),
        isAttachesEnabled,
        isDialogShown,
        isMountedFolder,
        hideAdsOnAttaches,
        showBottomAds,
        showEditButton,
        sharedFolderFile,
        sharedFolderFileBtnFeature,
        isEditable,
        pdfConverterStorage,

        storyId,
        storyType,
        bottomTitle,
        bottomSubTitle,
        topSubTitle,
        topTitle,
        disableZoom,
        isStoryViewed,
        faces,
        isNewAdFormat,
        isSearchAnalyticsRequestAvailable,
        attachesSearchedItemPos,
        disableClose,
        isOwner,
    };
};
const mapDispatchToProps = (dispatch, props) => ({
    showSnackbar: (data) => dispatch(showSnackbarAction(data)),
    publishItemAction: (data) => dispatch(publishItem(data)),
    markStoryAsViewed: ({ storyId, lastViewedId }) => dispatch(markStoryAsViewedAction({ storyId, lastViewedId })),
    selectItemIndexInArray: ({ itemIndex }) => dispatch(selectItemIndexInArrayAction({ itemIndex })),
    toggleFavorite: (item): void =>
        dispatch(
            item.isInFavorites
                ? removeFromFavorites({ items: [item] })
                : addToFavorites({
                      items: [item],
                      from: 'viewer',
                  })
        ),
    sendSearchRadar: (params) => dispatch(dispatchSearchRadar(params)),
    deleteFile: (item: CloudItem, itemStorage?: EStorageType, onSuccess = noopVoid) => removeItems({ items: [item], onSuccess }),
    onClose: () => {
        if (typeof props.onClose === 'function') {
            props.onClose();
        }
        dispatch(closeViewer());
    },
    downloadArchiveItemAction: (data) => dispatch(downloadArchiveItemRequest(data)),
    selectFace: (id) => {
        dispatch(selectFace({ id }));
    },
    getRenamedFileIdInsideViewer: () => dispatch(getRenamedFileIdInsideViewer()),
    clearRenamedFileIdInsideViewer: () => dispatch(clearRenamedFileIdInsideViewer()),
});
export const ReactViewerConnected = connect(mapStateToProps, mapDispatchToProps)(ReactViewerComponent);
